module.exports = __webpack_public_path__ + "b67c4d1830c5c5611f39d603d1116b39.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/message-24-info.png
// module id = 215
// module chunks = 0